import React, { useState } from 'react';
import { BrowserRouter, Routes, Route, Navigate, useNavigate } from 'react-router-dom';
import './App.css';
import { AuthProvider, useAuth } from './context/AuthContext';
import Loader from './Loader';
import Landing from './Landing';
import LoginModal from './LoginModal';
import ProtectedRoute from './ProtectedRoute';
import Dashboard from './pages/Dashboard';
import DashboardOverview from './pages/DashboardOverview';
import OrdersPage from './pages/OrdersPage';
import TripsPage from './pages/TripsPage';
import DispatchBoardPage from './pages/DispatchBoardPage';
import RoutesPage from './pages/RoutesPage';
import FleetPage from './pages/FleetPage';
import RoadsPage from './pages/RoadsPage';
import FarmersPage from './pages/FarmersPage';
import DriversPage from './pages/DriversPage';
import SettingsPage from './pages/SettingsPage';
import ActivityLogPage from './pages/ActivityLogPage';
import MessagesPage from './pages/MessagesPage';
import { MessagesProvider } from './context/MessagesContext';
import ServicesPage from './pages/ServicesPage';
import AboutPage from './pages/AboutPage';
import MissionPage from './pages/MissionPage';
import VisionPage from './pages/VisionPage';
import ContactPage from './pages/ContactPage';
import ScrollToTop from './components/ScrollToTop';

function AppContent() {
  const [loading, setLoading] = useState(true);
  const [showLogin, setShowLogin] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleLoaderComplete = () => {
    setLoading(false);
  };

  const handleLoginSuccess = (admin) => {
    login(admin);
    setShowLogin(false);
    navigate('/dashboard');
  };

  return (
    <div className="App">
      {loading ? (
        <Loader onComplete={handleLoaderComplete} />
      ) : (
        <>
          <Routes>
            <Route path="/" element={<Landing onLoginClick={() => setShowLogin(true)} />} />
            <Route path="/services" element={<ServicesPage onLoginClick={() => setShowLogin(true)} />} />
            <Route path="/about" element={<AboutPage onLoginClick={() => setShowLogin(true)} />} />
            <Route path="/mission" element={<MissionPage onLoginClick={() => setShowLogin(true)} />} />
            <Route path="/vision" element={<VisionPage onLoginClick={() => setShowLogin(true)} />} />
            <Route path="/contact" element={<ContactPage onLoginClick={() => setShowLogin(true)} />} />
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <MessagesProvider>
                    <Dashboard />
                  </MessagesProvider>
                </ProtectedRoute>
              }
            >
              <Route index element={<DashboardOverview />} />
              <Route path="orders" element={<OrdersPage />} />
              <Route path="trips" element={<TripsPage />} />
              <Route path="dispatch" element={<DispatchBoardPage />} />
              <Route path="routes" element={<RoutesPage />} />
              <Route path="fleet" element={<FleetPage />} />
              <Route path="roads" element={<RoadsPage />} />
              <Route path="farmers" element={<FarmersPage />} />
              <Route path="drivers" element={<DriversPage />} />
              <Route path="messages" element={<MessagesPage />} />
              <Route path="activity-log" element={<ActivityLogPage />} />
              <Route path="settings" element={<SettingsPage />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <LoginModal
            isOpen={showLogin}
            onClose={() => setShowLogin(false)}
            onSuccess={handleLoginSuccess}
          />
          <ScrollToTop />
        </>
      )}
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppContent />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
